<template>
  <b-card :header="caption">
    <b-row>
      <b-col sm="9">
        <b-link :to="{name: 'admin-create'}">
          <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
            创建管理员
          </b-button>
        </b-link>
      </b-col>
      <b-col sm="3">
        <b-form-input class="float-right" type="text" placeholder="模糊匹配姓名/邮箱" v-model="search" />
      </b-col>
    </b-row>
    <b-table responsive="sm" :items="items" :fields="fields" :current-page="currentPage" >
      <template #cell(admin_type)="data">
        {{getType(data.item.admin_type)}}
      </template>
      <template #cell(admin_op)="data">
        <b-link :to="{name: 'admin-update', params: {id: data.item._id}}">
          <b-button size="sm" variant="outline-primary">
          权限管理
          </b-button>
        </b-link>
        <b-button size="sm" variant="outline-danger" @click="deleteAdmin(data.index)" >删除</b-button>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="<<" next-text=">>" @change="changePage" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import utils from '@/utils/utils'
import consts from '@/utils/consts'
export default {
  name: 'admin',
  mixins: [Error],
  props: {
    caption: {
      type: String,
      default: '管理员'
    }
  },
  data: () => {
    return {
      items: [],
      fields: consts.ADMIN_FIELDS,
      currentPage: 1,
      perPage: consts.DEFAULT_PER_PAGE,
      totalRows: 0,
      search: ''
    }
  },
  created () {
    api.fetchListData(this, api.getAdminList(), 'admin_info')
  },
  watch: {
    search (val) {
      this.changePage(this.currentPage)
    }
  },
  methods: {
    changePage (page) {
      this.currentPage = page
      api.fetchListData(this, api.getAdminList(), 'admin_info', {query_key: this.search})
    },
    getType (type) {
      return utils.findInArray(consts.ADMIN_TYPES, type, 'text')
    },
    deleteAdmin (idx) {
      this.$ajax.delete(api.getAdminDelete(
        this.items[idx]._id
      )).then((res) => {
        this.$message.info('删除成功')
        api.fetchListData(this, api.getAdminList(), 'admin_info')
      }, (res) => {
        this.handleError(res)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Admin.vue?43b9794a